import React from "react";
import { IForm } from "../../../../types/form.type";
import { Grid2, Stack } from "@mui/material";
import TextInput from "../../input/TextInput";
import { Controller, useForm } from "react-hook-form";
import ModalForm from "../../modal/ModalForm";
import { asyncPostData, asyncPutData } from "../../../../utils/httpRequests";
import { useSelector } from "react-redux";
import NumberInput from "../../input/NumberInput";
import { numeralCustom } from "../../../../utils/helpers";
import DateInput from "../../input/DateInput";

function FormCRThuoc({
  defaultValues,
  isEdit,
  apiCode,
  open,
  freeMode,
  title,
  onClose,
  setLoad,
}: IForm) {
  const token = useSelector((state: any) => state.auth.token);
  const defaultData = {
    id: "",
    ten_thuoc: "",
    hoat_chat: "",
    hamluong: "",
    gdklh: "",
    duongdung: "",
    baoche: "",
    nhomthuoc: "",
    cssx: "",
    nuocsx: "",
    quycach: "",
    //
    dvt: "",
    hinh_thuc_lcnt: "",
    han_dung: "",
    soluong: 0,
    dongia: 0,
    tbmt: "",
    cdt: "",
    ngay_kqlcnt: null,
    soquyetdinh: "",
    ngayquyetdinh: null,
    slnhathau: 0,
    diadiem: "",
  };
  const originData = !!defaultValues
    ? {
        ...defaultData,
        ...defaultValues,
      }
    : defaultData;
  const {
    control,
    register,
    handleSubmit,
    formState: { isSubmitting },
  } = useForm({
    mode: "onSubmit",
    defaultValues: originData,
  });

  const handleSave = async (values: typeof defaultData) => {
    try {
      if (isEdit) {
        await asyncPutData({
          id: defaultValues?._id,
          apiCode,
          token,
          applyToken: true,
          withIdApp: true,
          data: values,
        });
      } else {
        await asyncPostData({
          apiCode,
          token,
          applyToken: true,
          withIdApp: true,
          data: values,
        });
      }
      onClose();
      setLoad?.((prev: number) => prev + 1);
    } catch (error: any) {
      alert(error?.error || error?.message || "Lưu không thành công");
    }
  };

  const onSubmit = handleSubmit(handleSave);

  return (
    <ModalForm
      formWidth="1000px"
      formTitle="thuốc"
      title={title}
      open={open}
      onClose={onClose}
      isEdit={isEdit}
      onSubmit={onSubmit}
      loading={isSubmitting}
    >
      <Grid2 container spacing={2}>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <Stack gap={2}>
            <TextInput
              multiline
              label="ID (BV)"
              id="id"
              labelWidth="25%"
              placeholder="Nhập ID"
              name="id"
              register={register}
            />
            <TextInput
              readOnly={!freeMode}
              multiline
              label="Tên thuốc"
              id="ten_thuoc"
              labelWidth="25%"
              placeholder="Nhập tên thuốc"
              name="ten_thuoc"
              register={register}
            />
            <TextInput
              readOnly={!freeMode}
              multiline
              label="Tên hoạt chất"
              labelWidth="25%"
              id="ten_hc"
              placeholder="Nhập tên hoặc chất"
              name="hoat_chat"
              register={register}
            />
            <TextInput
              readOnly={!freeMode}
              multiline
              label="Hàm lượng"
              id="hamluong"
              labelWidth="25%"
              placeholder="Nhập hàm lượng"
              name="hamluong"
              register={register}
            />
            <TextInput
              readOnly={!freeMode}
              multiline
              label="GDKLH hoặc GPNK"
              labelWidth="25%"
              id="gdklh"
              placeholder="Nhập GDKLH hoặc GPNK"
              name="gdklh"
              register={register}
            />
            <TextInput
              readOnly={!freeMode}
              multiline
              label="Đường dùng"
              id="duongdung"
              labelWidth="25%"
              placeholder="Nhập đường dùng"
              name="duongdung"
              register={register}
            />
            <TextInput
              readOnly={!freeMode}
              multiline
              label="Dạng bào chế"
              id="baoche"
              labelWidth="25%"
              placeholder="Nhập dạng bào chế"
              name="baoche"
              register={register}
            />
            <TextInput
              readOnly={!freeMode}
              multiline
              label="Nhóm thuốc"
              id="nhomthuoc"
              labelWidth="25%"
              placeholder="Nhập nhóm thuốc"
              name="nhomthuoc"
              register={register}
            />
            <TextInput
              readOnly={!freeMode}
              multiline
              label="Cơ sở sản xuất"
              id="cssx"
              labelWidth="25%"
              placeholder="Nhập cơ sở sản xuất"
              name="cssx"
              register={register}
            />
            <TextInput
              readOnly={!freeMode}
              multiline
              label="Nước sản xuất"
              id="nuocsx"
              labelWidth="25%"
              placeholder="Nhập nước sản xuất"
              name="nuocsx"
              register={register}
            />
            <TextInput
              readOnly={!freeMode}
              multiline
              label="Quy cách"
              id="quycach"
              labelWidth="25%"
              placeholder="Nhập quy cách"
              name="quycach"
              register={register}
            />
            <TextInput
              readOnly={!freeMode}
              multiline
              label="Đơn vị tính"
              id="dvt"
              labelWidth="25%"
              placeholder="Nhập đơn vị tính"
              name="dvt"
              register={register}
            />
          </Stack>
        </Grid2>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <Stack gap={2}>
            <TextInput
              // readOnly={!freeMode}
              multiline
              label="Hình thức LCNT"
              id="hinh_thuc_lcnt"
              labelWidth="25%"
              placeholder="Nhập hình thức LCNT"
              name="hinh_thuc_lcnt"
              register={register}
            />
            <TextInput
              // readOnly={!freeMode}
              multiline
              label="Hạn dùng"
              id="han_dung"
              labelWidth="25%"
              placeholder="Nhập hạn dùng"
              name="han_dung"
              register={register}
            />
            <NumberInput
              readOnly={!freeMode}
              label="Số lượng"
              min={0}
              id="soluong"
              labelWidth="25%"
              placeholder="Nhập số lượng"
              name="soluong"
              register={register}
            />
            <Controller
              control={control}
              name="dongia"
              render={({ field: { value, onChange } }) => {
                return (
                  <TextInput
                    readOnly={!freeMode}
                    label="Đơn giá"
                    id="dongia"
                    labelWidth="25%"
                    placeholder="Nhập đơn giá"
                    value={numeralCustom(value).format()}
                    onChange={(e) => {
                      const val = numeralCustom(e.target.value).value();
                      onChange(val);
                    }}
                  />
                );
              }}
            />
            <TextInput
              readOnly={!freeMode}
              multiline
              label="Mã TBMT"
              id="tbmt"
              labelWidth="25%"
              placeholder="Nhập mã TBMT"
              name="tbmt"
              register={register}
            />
            <TextInput
              readOnly={!freeMode}
              multiline
              label="Tên CĐT"
              id="cdt"
              labelWidth="25%"
              placeholder="Nhập tên CĐT"
              name="cdt"
              register={register}
            />
            <Controller
              control={control}
              name="ngay_kqlcnt"
              render={({ field: { value, onChange } }) => {
                return (
                  <DateInput
                    readOnly={!freeMode}
                    label="Ngày đăng tải KQLCNT"
                    labelWidth="25%"
                    value={value}
                    onChange={onChange}
                  />
                );
              }}
            />
            <TextInput
              readOnly={!freeMode}
              multiline
              label="Số quyết định"
              id="soquyetdinh"
              labelWidth="25%"
              placeholder="Nhập số quyết định"
              name="soquyetdinh"
              register={register}
            />
            <Controller
              control={control}
              name="ngayquyetdinh"
              render={({ field: { value, onChange } }) => {
                return (
                  <DateInput
                    readOnly={!freeMode}
                    label="Ngày quyết định"
                    labelWidth="25%"
                    value={value}
                    onChange={onChange}
                  />
                );
              }}
            />
            <NumberInput
              readOnly={!freeMode}
              label="Số lượng nhà thầu"
              min={0}
              id="slnhathau"
              labelWidth="25%"
              placeholder="Nhập số lượng nhà thầu"
              name="slnhathau"
              register={register}
            />
            <TextInput
              readOnly={!freeMode}
              multiline
              label="Địa điểm"
              id="diadiem"
              labelWidth="25%"
              placeholder="Nhập địa điểm"
              name="diadiem"
              register={register}
            />
          </Stack>
        </Grid2>
      </Grid2>
    </ModalForm>
  );
}

export default FormCRThuoc;
